import React from 'react'
import { Switch, Route, Redirect } from 'react-router-dom'
import homePage from './HomePage/homePage'
import './App.scss'
import { captchaSettings } from 'reactjs-captcha'

captchaSettings.set({
	captchaEndpoint: '/bdc4-simple-api-react-captcha-example/botdetectcaptcha',
})

const App = () => {
	return (
		<div className='App'>
			<Switch>
				<Redirect exact from='/' to='/home' />
				<Route path={`/home`} component={homePage} />
			</Switch>
		</div>
	)
}

export default App
